import { get } from 'lodash';
import { PROCEDURE_STATUSES, PROCEDURE_STEPS } from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';

export const formatDecision = (
  status: string,
  claimId: number,
  judgementAdd: {} | IJudgementAdd,
  rejectionReason: null | string = null,
  code_lawyer: any,
  toUpdate: boolean,
) => {
  return {
    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
    claimId,
    status: toUpdate ? get(judgementAdd, 'status') : status,
    id: get(judgementAdd, 'id'),
    rejectionReason,
    feeNote: {
      step: PROCEDURE_STEPS.ARRET_ADD,
      codeIntervenant: code_lawyer,
    },
    fflipFeeNote: featureService.hasFeature(FEATURES.FEE_NOTE),
    username: currentUserStorage.get().username,
  };
};
export const shouldDisplayAddDecisionMenu = (status: string): boolean =>
  status === PROCEDURE_STATUSES.PENDING;
